import { IonCheckbox, IonLabel } from '@ionic/react';
import { Color } from '../common/index.ts';

export interface ILabeledCheckboxProps {
    label: string;
    value: boolean;
    color?: Color;
    disabled?: boolean;
    onClick: () => void;
}

export const LabeledCheckbox: React.FC<ILabeledCheckboxProps> = ({label, value, color = 'primary', disabled, onClick}) => {
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: disabled ? undefined : 'pointer'
    };

    const handleClick = () => {
        if (onClick && !disabled) {
            onClick();
        }
    };

    return (
        <div style={style} onClick={handleClick}>
            <IonCheckbox color={color} disabled={disabled} checked={value} />
            <IonLabel>{label}</IonLabel>
        </div>
    );
};
